(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feedback', {
            parent: 'app',
            url: '/feedback',
            data: {
                authorities: [],
                pageTitle: 'nasracApp.feedback.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/feedback/feedback.html',
                    controller: 'FeedbackController',
                    controllerAs: 'FeedbackCtrl'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('feedback');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
